/**
 * ConnectedFormLookupField — wires FormLookupField (the "normal + gear" control, in
 * @atlas-forms/ui-components-react/form-lookup) to AtlasFormsClient. Lives HERE
 * (designer-components-react), not alongside the base component, because
 * @atlas-forms/client-js pulls in the transitive source of ~8 other js-layer packages —
 * adding it to ui-components-react's dependencies breaks that package's rootDir-scoped
 * `tsc` build (confirmed by a real build failure during Task 35). designer-components-react
 * already depends on client-js safely, so the "connected" wrappers live here instead.
 * Use FormLookupField directly (from ui-components-react) when you need to inject a
 * custom data source from a package that can't safely depend on client-js.
 */

import React from 'react';
import { FormLookupField, type FormLookupFieldProps } from '@atlas-forms/ui-components-react';
import { fetchForms, loadForm } from './connectedFormLookup';

type ConnectedProps = Omit<FormLookupFieldProps, 'fetchForms' | 'loadForm'>;

export const ConnectedFormLookupField: React.FC<ConnectedProps> = (props) => (
  <FormLookupField {...props} fetchForms={fetchForms} loadForm={loadForm} />
);
